// Port of api/fuel/app/classes/controller/api/monty/tags/move.php
import DB from 'offline/db'
import {
	loadOwnedFamily,
	loadOwnedTag,
	persist,
	sessionUserId,
	tagToArray,
	unauthorised
} from './shared'

export default function(params) {
	var userId = sessionUserId(params)
	var tag = false
	var to = params.to
	var family = false
	var familyId = 0

	if (!userId) {
		return unauthorised()
	}

	tag = loadOwnedTag(userId, params.tag)
	if (!tag) {
		return unauthorised()
	}

	if (to !== 'none') {
		family = loadOwnedFamily(userId, to)
		if (!family) {
			return unauthorised()
		}
	}

	if (family) {
		familyId = parseInt(family.family_id, 10) || 0

		DB.run('UPDATE tag SET tag_context = ?, tag_public = ?, tag_colour = ?, tag_fore = ?, family_id = ? WHERE tag_id = ?', [
			parseInt(family.family_context, 10) || 0,
			parseInt(family.family_public, 10) || 0,
			(parseInt(family.family_style, 10) || 0) ? (family.family_colour || '') : (tag.tag_colour || ''),
			(parseInt(family.family_style, 10) || 0) ? (family.family_fore || '') : (tag.tag_fore || ''),
			familyId,
			parseInt(tag.tag_id, 10) || 0
		])

		DB.run('UPDATE tag_attach SET family_id = ? WHERE user_id = ? AND tag_id = ?', [
			familyId,
			parseInt(userId, 10) || 0,
			parseInt(tag.tag_id, 10) || 0
		])
	} else {
		DB.run('UPDATE tag SET family_id = ? WHERE tag_id = ?', [
			0,
			parseInt(tag.tag_id, 10) || 0
		])

		DB.run('UPDATE tag_attach SET family_id = ? WHERE user_id = ? AND tag_id = ?', [
			0,
			parseInt(userId, 10) || 0,
			parseInt(tag.tag_id, 10) || 0
		])
	}

	var rows = DB.query('SELECT * FROM tag WHERE tag_id = ?', [tag.tag_id])
	return persist(tagToArray(rows[0]))
}
